import { createReducer, INITIAL_STATE } from '@shared/redux';

export const FORGOT_PASSWORD_SUBMITTED = '@auth/FORGOT_PASSWORD_SUBMITTED';
export const FORGOT_PASSWORD_ACCEPTED = '@auth/FORGOT_PASSWORD_ACCEPTED';
export const FORGOT_PASSWORD_REJECTED = '@auth/FORGOT_PASSWORD_REJECTED';

export const isForgotPasswordLoading = state => state.auth.forgotPassword.loading;
export const isCodeSent = state => state.auth.forgotPassword.codeSent;

export const submitForgotPassword = ({ username }) => ({
    type: FORGOT_PASSWORD_SUBMITTED,
    payload: { username },
});

export const acceptForgotPassword = ({ user }) => ({
    type: FORGOT_PASSWORD_ACCEPTED,
    payload: { user },
});

export const rejectForgotPassword = ({ code, error }) => ({
    type: FORGOT_PASSWORD_REJECTED,
    payload: { code, error },
});

export const forgotPasswordReducer = createReducer({
    [INITIAL_STATE]: {
        loading: false,
        codeSent: false,
    },

    [FORGOT_PASSWORD_SUBMITTED]: state => ({ ...state, loading: true, codeSent: false }),
    [FORGOT_PASSWORD_ACCEPTED]: state => ({ ...state, loading: false, codeSent: true }),
    [FORGOT_PASSWORD_REJECTED]: state => ({ ...state, loading: false, codeSent: false }),
});
